import { SkyLink, SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { Link } from "wouter";
import {
  isComingSoon,
  readinessReasonLine,
  useDestinationReadiness,
} from "@/hooks/use-destination-readiness";
import { usePermissions } from "@/hooks/use-permissions";
import { ROUTES } from "@/lib/routes";
import { ASK_ADMIN_DESTINATION } from "@/lib/transformations/dbtSettings";
import {
  DATABRICKS_COMING_SOON_MESSAGE,
  DESTINATION_DRAFT_BANNER,
  DESTINATION_NOT_SET_MESSAGE,
} from "@shared/warehouse/destinationReadiness";

/**
 * #375, #923: above every instance screen, for every role, while the destination is not set or
 * is a Draft: nothing that writes data runs until it is Ready (the due scan skips, Run now is a
 * 409). Nothing is shown while the answer is unknown or the destination is Ready.
 */
export function DestinationReadinessBanner() {
  const readiness = useDestinationReadiness();
  // #1106: the Destination tab is Instance admin and above. Anyone else gets no link to it, and
  // reads who acts instead.
  const { canAny } = usePermissions();
  const canOpenDestination = canAny("instance.binding.read");
  if (!readiness || readiness.state === "ready") return null;
  const reason = readinessReasonLine(readiness);
  const sentence =
    readiness.state === "not_set"
      ? DESTINATION_NOT_SET_MESSAGE
      : isComingSoon(readiness)
        ? DATABRICKS_COMING_SOON_MESSAGE
        : reason
          ? `${DESTINATION_DRAFT_BANNER} ${reason}`
          : DESTINATION_DRAFT_BANNER;
  const message = canOpenDestination ? sentence : `${sentence} ${ASK_ADMIN_DESTINATION}`;
  return (
    <div className="mb-4">
      <SkyMessageBar
        intent="warning"
        layout="multiline"
        testId="destination-readiness-banner"
        message={message}
        actions={
          canOpenDestination ? (
            <SkyLink as={Link} href={ROUTES.settingsDestination} testId="destination-banner-link">
              Open Destination
            </SkyLink>
          ) : undefined
        }
      />
    </div>
  );
}
